/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.combos.create.schedule.controllers', [
  'acme.common.service.api'
])

.controller('ProgramsCombosCreateScheduleController', ['$scope', '$state', 'ApiService', 'CalendarService', function($scope, $state, ApiService, CalendarService) {

    $scope.programsCombosCreateSchedule = {

      model: {
        startTime: new Date(),
        endTime: new Date(),
        singleDay: false
      },

      isSubmitted: false,
      cachedEndTime: null,
      combo : null,

      init: function() {
        var title,
            titleLabel = 'Create Combo Schedule';

        $scope.$on("ProgramsCombosCreateController::save", this.onSave);

        console.log('programsCombosCreateSchedule::state', $state);
        if ($state.params && $state.params.comboId) {
          this.getCombo($state.params.comboId);
          titleLabel = 'Edit Combo Schedule';
        }

        title = {
          title: titleLabel,
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.programs.combos.list');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            action: function() {
              $scope.programsCombosCreateSchedule.complete(true);
            }
          }
        };

        $scope.$watch('programsCombosCreateSchedule.model.singleDay', this.onSingleDayUpdate);
        $scope.$watch('programsCombosCreateSchedule.model.startTime', this.onStartTimeUpdate);

        $scope.$emit('Application::contentTitleChange', title);

      },

      isValid: function() {
        return (this.isValidDateRange());
      },

      isValidDateRange: function() {
        var r = true;

        if (this.isSubmitted) {
          r = (this.model.endTime && this.model.startTime && (this.model.endTime.getTime() - this.model.startTime.getTime()) > 1);
        }

        return r;
      },

      onSave: function(e, data) {
        var self = $scope.programsCombosCreateSchedule;
        self.next = data.state;
        self.complete();
      },

      complete : function(close) {
        var errorHandler = (close) ? this.error.saveAndClose : this.error.complete,
            successHandler = (close) ? this.success.saveAndClose : this.success.complete;

        $scope.$emit('ProgramsCombosCreateController::reset');
        this.isSubmitted = true;

        console.log('ProgramsCombosCreateScheduleController::complete', this.model.startTime.getTime(), this.model.endTime.getTime());

        if (this.isValid()) {
          if (this.combo && this.combo.id) {
            ApiService.combo.templates.update(this.marshal.toJSON()).then(successHandler, errorHandler);
          } else {
            ApiService.combo.templates.create(this.marshal.toJSON()).then(successHandler, errorHandler);
          }
        }else{
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  'Please correct the errors below.'
          });
        }
      },


      getCombo : function(id) {
        ApiService.combo.templates.get(id).then(this.success.getCombo, this.error.getCombo);
      },

      success: {
        init: function(response) {},

        getCombo: function(response) {
          var self = $scope.programsCombosCreateSchedule;
          self.marshal.fromJSON(response.data.payload);
          console.log('programsCombosCreateSchedule::getCombo', self);
        },

        complete: function(response) {
          var self = $scope.programsCombosCreateSchedule;
          self.isSubmitted = true;
          $state.go(self.next, { comboId: response.data.payload.id });
        },

        saveAndClose: function(response) {
          $scope.programsCombosCreateSchedule.isSubmitted = true;
          $scope.$emit('ProgramsCombosCreateController::success', {
            message: 'Successfully Saved!'
          });

          $scope.$emit('ProgramsCombosCreateController::transition', {
            state: 'application.programs.combos.list'
          });
        }
      },

      error: {
        init: function(response) {},
        getCombo: function(response) {},
        complete: function(response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        },
        saveAndClose: function(response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        }
      },

      marshal: {
        fromJSON : function(json) {
          var diff,
              days = (((1000 * 60) * 60) * 24),
              self = $scope.programsCombosCreateSchedule;

          self.model.startTime = CalendarService.parseDate(json.startTime);
          self.model.endTime = CalendarService.parseDate(json.endTime);

          diff = (self.model.endTime.getTime() - self.model.startTime.getTime()) / days;
          if (diff < 1) {
            self.model.singleDay = true;
          }
          self.combo = json;
        },

        toJSON : function() {
          var self = $scope.programsCombosCreateSchedule;

          self.model.startTime = new Date(self.model.startTime);
          self.model.startTime.setHours(0);
          self.model.startTime.setMinutes(0);
          self.model.startTime.setSeconds(0);
          self.model.startTime.setMilliseconds(0);

          self.model.endTime = new Date(self.model.endTime);
          self.model.endTime.setHours(23);
          self.model.endTime.setMinutes(59);
          self.model.endTime.setSeconds(59);
          self.model.endTime.setMilliseconds(999);

          if (self.combo) {
            self.combo.startTime = CalendarService.toISO8601(self.model.startTime);
            self.combo.endTime = CalendarService.toISO8601(self.model.endTime);
          } else {
            self.combo = {
              startTime: CalendarService.toISO8601(self.model.startTime),
              endTime: CalendarService.toISO8601(self.model.endTime)
            };
          }

          return self.combo;
        }
      },

      onStartTimeUpdate: function(n, o) {
        var self = $scope.programsCombosCreateSchedule,
            d = new Date(self.model.startTime);

        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(999);

        if (self.model.singleDay) {
          self.model.endTime = d;
        }else if (self.model.endTime) {
          if (self.model.startTime.getTime() > self.model.endTime.getTime()) {
            self.model.endTime = d;
          }
        }
      },

      onSingleDayUpdate: function(n, o) {
        var self = $scope.programsCombosCreateSchedule,
            d = new Date(self.model.startTime);

        if (n) {
          self.cachedEndTime = angular.copy(self.model.endTime);
          d.setHours(23);
          d.setMinutes(59);
          d.setSeconds(59);
          d.setMilliseconds(999);
          self.model.endTime = d;
        }else{
          self.model.endTime = angular.copy(self.cachedEndTime);
        }
      }

    };

    $scope.programsCombosCreateSchedule.init();

}]);